import React from 'react'
import IProps from './interface'
import classNames from 'classnames'

const Link = (props: IProps) => {
  const {
    id,
    href,
    target,
    label,
    type = 'primary',
    color = 'primary',
    size = 'base',
    fullWidth = false,
    wrappable = false,
    animated = false,
    customClasses,
    ignoreSectionThemes,
    children,
  } = props

  return (
    <a
      href={href}
      {...(id ? { id } : {})}
      {...(target ? { target } : {})}
      {...(target === '_blank' ? { rel: 'noopener noreferrer' } : {})}
      {...(label ? { 'aria-label': label } : {})}
      className={classNames(
        {
          ['link']: true,
          [`link__color--${color}`]: color,
          [`link__type--${type}`]: type,
          [`link__size--${size}`]: size,
          ['link__fullWidth']: fullWidth,
          ['link__wrappable']: wrappable,
          ['link__ignoreSectionThemes']: ignoreSectionThemes,
          [`link__animated`]: animated,
        },
        customClasses || ''
      )}>
      {children}
    </a>
  )
}

export default Link
